import { ModalType } from '@philips-internal/oswald-ui-constants';
function createModalService() {
    const closeListeners = new Set();
    const listeners = new Set();
    const addCloseListener = (fn) => {
        if (closeListeners.has(fn)) {
            throw Error('[Modal Service]: This listener is already listening to close events.');
        }
        closeListeners.add(fn);
        return () => {
            closeListeners.delete(fn);
        };
    };
    const addListener = (fn) => {
        if (listeners.has(fn)) {
            throw Error('[Modal Service]: This listener is already listening to new modals');
        }
        listeners.add(fn);
        return () => {
            listeners.delete(fn);
        };
    };
    const close = (id) => {
        closeListeners.forEach((listener) => {
            listener(id);
        });
    };
    const openDefault = (configuration) => {
        configuration.type = ModalType.DEFAULT;
        openModal(configuration);
    };
    const openDialog = (configuration) => {
        configuration.type = ModalType.DIALOG;
        openModal(configuration);
    };
    const openFullscreen = (configuration) => {
        configuration.type = ModalType.FULLSCREEN;
        openModal(configuration);
    };
    const openModal = (configuration) => {
        listeners.forEach((listener) => {
            listener(configuration);
        });
    };
    return {
        addCloseListener,
        addListener,
        close,
        openDefault,
        openDialog,
        openFullscreen,
    };
}
const ModalService = createModalService();
export { ModalService, };
//# sourceMappingURL=modal-service.js.map